'use client'

import tucanLogoDark from 'components/logo/tucan.logo.dark.svg'
import { CenterCard } from '@tucan/login'
import React, { CSSProperties, ReactNode } from 'react'
import { getPublicEnv } from '@tucan/utils'
import { PageCenter } from './page.center'

interface Props {
  /** Image above the content, e.g. a company logo; default `LOGO_URL`, then Tucan's logo. */
  logo?: string
  logoAlt?: string
  children: ReactNode
  cardStyle?: CSSProperties
}

/**
 * `@tucan/login`'s centered card on a ui page, with the deployment's logo (`LOGO_URL`) and home
 * icon (`ICON_URL`), both Tucan's logo when unset.
 */
export const PageCenterCard: React.FC<Props> = (props) => (
  <PageCenter footer>
    <CenterCard
      logo={props.logo || getPublicEnv('LOGO_URL') || tucanLogoDark.src}
      logoAlt={props.logoAlt}
      icon={getPublicEnv('ICON_URL') || tucanLogoDark.src}
      cardStyle={props.cardStyle}
    >
      {props.children}
    </CenterCard>
  </PageCenter>
)
